import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class DeleteUserMutation extends Mutation {
  document = gql`
    mutation deleteUser($id: ID!) {
      deleteUser(where: {id: $id}) {
        id
        keycloakID
        stripeID
      }
    }
  `;
}
